import "../styles/pages/Page2.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/axiosConfig";
import JoinGroupModal from "../components/dashboard/JoinGroupModal";
import GroupCard from "../components/dashboard/GroupCard";
import Navbar from "../components/common/Navbar";
import FotographiyaSlideBar from "../components/dashboard/FotographiyaSlideBar";
import {
  Sparkles,
  Camera,
  Globe,
  Star,
  ArrowRight,
  ExternalLink,
  Menu,
  Plus,
} from "lucide-react";

const UserDashboard = () => {
  const [groups, setGroups] = useState([]);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showSlideBar, setShowSlideBar] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const fetchGroups = () => {
    api
      .get("/groups/joined")
      .then((res) => {
        console.log("👉 joined data:", res.data);
        setGroups(res.data.groups || res.data);
      })
      .catch((err) => console.error("Error fetching groups:", err))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const hasGroups = Array.isArray(groups) && groups.length > 0;

  return (
    <>
      <Navbar />
      <main className="page2">
        <div className="back">
          {/* 🌟 Fotographiya Big Center Watermark Logo */}
          <div className="foto-bg-watermark" aria-hidden="true">
            <img
              src="/images/logo-middle.png"
              alt="Fotographiya Watermark"
              className="foto-bg-watermark-img"
            />
          </div>

          <div className="text">
            <h1>Your Albums</h1>
            <div className="right-text">
              <button
                type="button"
                className="foto-btn-slidebar-trigger"
                onClick={() => setShowSlideBar(true)}
                title="Explore Fotographiya Studio, Social Links & Services"
              >
                <Sparkles size={15} strokeWidth={2.2} />
                <span>Fotographiya Hub</span>
                <Menu size={14} strokeWidth={2.2} />
              </button>
              <button
                className="button1"
                onClick={() => setShowJoinModal(true)}
              >
                <Plus size={16} strokeWidth={2.5} />
                <span>Join Album</span>
              </button>
            </div>
          </div>

          {/* Group / Album List or Skeleton */}
          {isLoading ? (
            <div className="group-list">
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="skeleton-card">
                  <div className="skeleton skeleton-thumbnail"></div>
                  <div className="group-info">
                    <div className="skeleton skeleton-title"></div>
                    <div className="skeleton skeleton-count"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : hasGroups ? (
            <div className="group-list">
              {groups.map((group, index) => (
                <div
                  key={group._id}
                  className="animate-card-fade-up"
                  style={{
                    animationDelay: `${Math.min(index * 0.05, 0.5)}s`,
                  }}
                >
                  <GroupCard
                    group={group}
                    onClick={() => navigate(`/group/${group._id}`)}
                  />
                </div>
              ))}
            </div>
          ) : (
            /* Smart Welcoming Empty State (Clean & Informative, pointing to single Join Album button) */
            <div
              className="foto-empty-albums-card"
              onClick={() => setShowJoinModal(true)}
              title="Click to Join an Event Album"
              style={{ cursor: "pointer" }}
            >
              <div className="foto-empty-icon">
                <Camera size={26} strokeWidth={1.8} />
              </div>
              <h3 className="foto-empty-title">No Event Albums Joined Yet</h3>
              <p className="foto-empty-desc">
                Attending a wedding, party, or celebration? Click <strong>+ Join Album</strong> above to enter your 6-digit Event Code or scan the event QR code to find all your photos using AI face match!
              </p>
            </div>
          )}

          {/* ✨ Fotographiya Quick Discovery Strip (Compact, High-Contrast & Sleek) */}
          <div className="foto-compact-strip">
            <div className="foto-strip-left">
              <div className="foto-strip-icon-badge">
                <Sparkles size={18} strokeWidth={2.2} />
              </div>
              <div className="foto-strip-text">
                <h4 className="foto-strip-title">Fotographiya Studios & Portfolios</h4>
                <p className="foto-strip-subtitle">
                  Discover luxury wedding stories, portfolios, reviews & social channels
                </p>
              </div>
            </div>

            <div className="foto-strip-actions">
              <a
                href="https://www.fotographiya.com"
                target="_blank"
                rel="noopener noreferrer"
                className="foto-strip-link-btn btn-strip-website"
                title="Visit Fotographiya Official Website"
              >
                <Globe size={13} strokeWidth={2} />
                <span>fotographiya.com</span>
                <ExternalLink size={11} strokeWidth={2} />
              </a>

              <a
                href="https://g.page/r/CZRiMBryiw02EAI/review"
                target="_blank"
                rel="noopener noreferrer"
                className="foto-strip-link-btn btn-strip-review"
                title="Rate Us on Google"
              >
                <Star
                  size={12}
                  fill="#f59e0b"
                  color="#f59e0b"
                  strokeWidth={1}
                />
                <span>4.9 Reviews</span>
              </a>

              <button
                type="button"
                className="foto-strip-link-btn btn-strip-open-drawer"
                onClick={() => setShowSlideBar(true)}
                title="Open Fotographiya Slide Bar"
              >
                <span>Explore All Services</span>
                <ArrowRight size={13} strokeWidth={2.2} />
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Slide Bar (Sliding Drawer) */}
      <FotographiyaSlideBar
        isOpen={showSlideBar}
        onClose={() => setShowSlideBar(false)}
      />

      <JoinGroupModal
        showModal={showJoinModal}
        onClose={() => setShowJoinModal(false)}
        onJoinSuccess={fetchGroups}
      />
    </>
  );
};

export default UserDashboard;
